globalThis.showPaywallTab =  function(event,tab){
    // Declare all variables
    let i, tabcontent, tablinks;

    const active = "text-lg sm:text-xl font-medium text-neutral-100 pwmenu";
    const inactive = "text-lg sm:text-xl text-neutral-60 hover:text-neutral-100 pwmenu";

    // Get all elements with class="tabcontent" and hide them
    tabcontent = document.getElementsByClassName("paywall_content");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }

    // Get all elements with class="tablinks" and remove the class "active"
    tablinks = document.getElementsByClassName("pwmenu");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].classList=inactive;
    }

    // Show the current tab, and add an "active" class to the button that opened the tab
    document.getElementById(tab).style.display = "block";

    event.currentTarget.classList = active;
}
